let colorContainer = document.querySelector(".form__label.color__label span");
let colorContainer2 = document.getElementById("selectedColor2");
let colorContainer3 = document.getElementById("selectedColor3");
let counter = 0;
var size_selected = null;

let radios = document.querySelectorAll('input[type=radio][name="Color"]');
let radios2 = document.querySelectorAll('input[type=radio][name="Size"]');

radios.forEach((radio) => {
    radio.addEventListener("change", () => {
        if (colorContainer) colorContainer.innerHTML = radio.value;
        if (colorContainer2) colorContainer2.innerHTML = radio.value;
        if (colorContainer3) colorContainer3.innerHTML = radio.value;
        updateSizeAvailable(radio.value, false);
    });
    if (radio.checked) {
        updateSizeAvailable(radio.value, true);
    }
});


function updateSizeAvailable(colorOption, firstRound = false) {
    const variantForm = document.getElementById("product-variants");
    const variants = JSON.parse(variantForm.querySelector('[type="application/json"]').textContent);
    var variantsSize = variantForm.querySelectorAll("[data-pdp-size]");

    for (let size of variantsSize) {
        const sizeSelected = size.querySelector("input[type=radio]");
        if ((!size.classList.contains("hidden") || firstRound) && sizeSelected.checked) {
            size_selected = sizeSelected.value;
            break;
        }
    }

    if (!firstRound) {
        const cachedSizeWrapper = cachedSizeSelector.cloneNode(true);
        document.querySelector(sizeSelectorId).replaceWith(cachedSizeWrapper);
    }

    variantsSize = variantForm.querySelectorAll("[data-pdp-size]");

    const variantsFiltered = variants.filter((option) => {
        return option.option1 === colorOption || option.option2 === colorOption;
    });

    variantsSize.forEach((size) => {
        size.classList.add("hidden")
    });

    variantsSize.forEach((size) => {
        variantsFiltered.forEach((variant) => {
            if (size.dataset.pdpSize === variant.option2) {
                size.classList.remove("hidden")
            }
        });
    });

    let optionSelected = false;
    for (let size of variantsSize) {
        if (!size.classList.contains("hidden")) {
            const sizeSelected = size.querySelector("input[type=radio]");
            if (!sizeSelected.dataset.disabled && sizeSelected.value == size_selected) {
                sizeSelected.checked = true;
                optionSelected = true;
                break;
            }
        }
    }

    if (!optionSelected) {
        for (let size of variantsSize) {
            if (!size.classList.contains("hidden")) {
                const sizeSelected = size.querySelector("input[type=radio]");
                if (!sizeSelected.dataset.disabled) {
                    sizeSelected.checked = true;
                    size_selected = sizeSelected.value;
                    break;
                }
            }
        }
    }
    window.Klarna.OnsiteMessaging.refresh();
    rebuildCarouselSize();
}